import { STORAGE_KEYS } from 'consts';

export const getRefreshToken = () =>
  window.localStorage.getItem(STORAGE_KEYS.refreshToken);
